<template>
    <div class="select" v-bind:class="[{'active':showList},{'multiple':multiple},{'empty':isEmpty}]" :data-key="attr">
        <div class="select-placeholder" v-if="!selectedValue || selectedValue == 0"  v-on:click="showList = !showList">
            <template v-if="selectedPlaceholder && selectedValue < 1">
                {{ selectedPlaceholder }}
            </template>
            <template v-else-if="selectedPlaceholder">
                {{selectedPlaceholder}}
            </template>
            <template v-else>
                - Wybierz -
            </template>
        </div>
        <div class="select-label" v-if="selectedValue && selectedValue != 0" v-on:click="showList = !showList">
            <template v-if="selectedKey">
             {{ selectedValue[selectedKey] }}
            </template>
            <template v-else-if="typeof(selectedValue) === 'object'">
                <template v-if="selectedValue.length === 1">
                {{ selectedValue[0] }}
                </template>
                <template v-else-if="selectedValue.length > 0">
                Wybrano {{ selectedValue.length }}
                </template>

            </template>     
            <template v-else>
                {{ selectedValue }}
            </template>
        </div>
        <div class="select-list" v-show="showList" v-on:click="toggle()">
            <slot name="list"></slot>
        </div>
        <span class="btn wide pointer"  v-on:click="toggle(true)" v-if="showList && multiple && $slots.list && listHeight > 1" :style="{'top':listHeight+'px'}"> Zatwierdź</span>
    </div>
</template>
<script>
    export default {
        name: 'SelectInput',
        props: {
            multiple: false,
            selectedValue: false,
            selectedKey: false,
            selectedPlaceholder:false,
            checkEmpty:true
        },
        data() {
            return{
                showList:false,
                listHeight:1,
                attr:Math.round(Math.random()*1000),
                observer:null,
                isEmpty:false
            }
        },
        watch:{
            showList:{
                handler(status){
                    // This closes options when you click outside input
                    var that = this;
                    if(status){
                        setTimeout(function(){
                            var elem = document.querySelector('.select.active');                         
                                document.addEventListener('click', function(event) {
                                    if(elem != null){
                                        var isClickInside = elem.contains(event.target);
                                        if (!isClickInside) {
                                            that.showList = false;
                                        }
                                    }
                                });                                                                
                                let element = that.$el.querySelector('.select-list');                                
                                that.listHeight = element.offsetHeight+36;
                        },100);
                        

                        
                        
                    }else{
                        document.removeEventListener("click",(e) => {
                            e.preventDefault();
                        },false);
                    }

                }
            }
        },
        methods:{
            toggle(mode = false){
                if(!this.multiple){
                    this.showList = false
                }else{
                    if(mode){
                        this.showList = false
                    }
                }
            },
            observeListChanges(){
                this.isEmpty = !this.$el.querySelector('.select-list').childNodes.length;
                this.observer = new MutationObserver((mutations) => {
                    this.isEmpty = !this.$el.querySelector('.select-list').childNodes.length;
                });
                this.observer.observe(
                    this.$el.querySelector('.select-list'),
                    { attributes: true, childList: true, characterData: true, subtree: true }
                );
            }
        },
        mounted(){
            if(this.checkEmpty){
                this.observeListChanges();
            }
        }
    }
</script>
<style lang="scss">
    // @import '~/assets/scss/_variables.scss';
    .select{
        position: relative;
        max-height: 50px;
        width: 100%;
        z-index: 1;
        border-bottom: 1px solid $gray;
        font-size: 1.25rem;
        &.active{
            z-index: 9999;
            .select-tick{
                transform: translateY(-50%) rotate(90deg);
            }
        }
        &.empty{
            .select-placeholder{
            }
        }
        &-label, &-placeholder{
            margin-top: .5rem;
            padding: .75rem 1.25rem;
            background-color: $white;
            width: 100%;
            border-radius: .25rem;
            color: $gray;
        }
        &-placeholder{
            color: $gray;
        }
        &-list{
            box-shadow: -5px -5px 35px -24px rgba(0,0,0,0.75);
            border: 1px solid $gray;
            background-color: $white;
            // color: $darkblue;
            border-radius: .25rem;
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            margin-top: 100%;
            max-height: 30vh;
            overflow-y: auto;
            z-index: 999999;
            transform: translateY(100%) translateZ(100px);
            min-width: 145px;
            ul{
                list-style: none;
                margin: 0;
                padding: 0;
                transform:translateZ(20px);
                z-index: 9999;
                li{
                    cursor: pointer;
                    padding: .25rem 1.25rem;
                    position:relative;
                    &:hover{
                        background-color: $gray;
                    }
                    &.active{
                        &::after{
                            content: '✓';
                            width: 1rem;
                            height: 1rem;
                            background-color: $blue;
                            display:block;
                            position: absolute;
                            right: .5rem;
                            top: .35rem;
                            border-radius:.25rem;
                            text-align: center;
                            color: #fff;
                            line-height: 1.2;
                            font-size:.8rem;
                        }
                    }
                }
            }
            /* width */
            &::-webkit-scrollbar {
            width: .75rem;
            }

            /* Track */
            &::-webkit-scrollbar-track {
            background: $gray;
            }

            /* Handle */
            &::-webkit-scrollbar-thumb {
                background: $blue;
            }

            /* Handle on hover */
            &::-webkit-scrollbar-thumb:hover {
            background: #555;
            }
        }
        &-button{
            border-radius: 0;
        }
        &-tag{
            background: $blue;
            color: $white;
            margin-right: .25rem;
            padding: .25rem 1rem;
            border-radius: .25rem;
            display: inline-block;
        }
        &.multiple{
            ul{
                margin-bottom: 1;
            }
        }
        &-tick{
            position: absolute;
            right: 1rem;
            top: 50%;
            transform: translateY(-50%) rotate(-90deg);
            user-select: none;
        }
        .accept{
            border-radius: .25rem;
            height: 3rem;
        }
        .btn{
            position: absolute;
            z-index: 999;
            // bottom: 100%;
            border-top-left-radius: 0;
            border-top-right-radius: 0;
        }
    }
</style>